<template>
  <div class="toast-snackbar-queue">
    <v-snackbar-queue
      v-model="toastQueue"
      location="bottom right"
      display-strategy="overflow"
      :total-visible="5"
      closable
      close-on-content-click
    >
      <template #actions="{ props: actionsProps }">
        <s-btn-icon
          class="toast-snackbar-btn"
          variant="text"
          icon="mdi-close"
          size="small"
          @click="actionsProps.onClick"
        />
      </template>
    </v-snackbar-queue>
  </div>
</template>

<script setup lang="ts">
const { toastQueue } = useToast();
</script>
